<main class="app-shell">
  <p-toast 
    position="top-center"
    [style]="{ width: '380px' }"
  ></p-toast>
  <router-outlet></router-outlet>

  <lib-caller-contact-popup></lib-caller-contact-popup>
</main>